module.exports = __webpack_public_path__ + "img/banner3.3b2330c1.png";